import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Box, Typography } from "@mui/material"
import { CAMPAIGN_STATUSES } from "campaign/model"
import { getStatusColor, getStatusIconProp, getStatusTranslation } from "campaign/tools/status"
import React from "react"

interface ICampaignStatusProps {
  status: CAMPAIGN_STATUSES | null
  isDspDeal?: boolean
  forList?: boolean
  id?: string
}

export const CampaignStatus = React.memo(({ status, isDspDeal, forList, id }: ICampaignStatusProps): JSX.Element => {
  if (!status) {
    status = CAMPAIGN_STATUSES.TEMPORARY
  }
  const color = getStatusColor(status)
  const filled = status === CAMPAIGN_STATUSES.ACTIVE
  return (
    <Box
      sx={{
        "p": forList ? "" : "1rem",
        "pt": forList ? ".3rem" : ".5rem",
        "pb": forList ? ".3rem" : ".5rem",
        "borderRadius": ".8rem",
        "display": "flex",
        "alignItems": "center",
        "justifyContent": "center",
        "border": forList || (!forList && filled) ? undefined : `2px solid ${color}`,
        "backgroundColor": !forList && filled ? color : undefined,
        "& .status-icon": {
          color: !forList && filled ? "white" : color,
          mr: ".5rem",
          fontSize: forList ? "1rem" : ".8rem",
          fontWeight: 300
        }
      }}>
      <FontAwesomeIcon icon={getStatusIconProp(status)} className="status-icon" />
      <Typography id={id} sx={{ color: !forList && filled ? "white" : color, fontSize: ".8rem" }}>
        {getStatusTranslation(status, isDspDeal).toUpperCase()}
      </Typography>
    </Box>
  )
})
